import { useEffect } from 'react';
import { htmlLangAttribute, uiLanguageFromPais } from '../../locale/uiLanguage';

/**
 * Sets document.documentElement.lang from empresa país (US → English).
 * Full English copy still requires i18n strings across the app; this enables
 * accessibility, browser translation hints, and future i18n wiring.
 */
export function SyncDocumentLang({ pais }: { pais: string | undefined | null }) {
  useEffect(() => {
    const lang = uiLanguageFromPais(pais);
    document.documentElement.lang = htmlLangAttribute(lang);
  }, [pais]);

  return null;
}
